export default {
    "lang": "印地语",
    "application": {
        "name": "सूचना प्रकाशन प्रणाली"
    },
    "ajaxTip": {
        "success": "सफल",
        "error": "विफल",
        "noAccess": "इस संसाधन तक पहुंच का अधिकार नहीं",
        "notFound": "एक्सेस किया गया संसाधन मौजूद नहीं",
        "serverBusy": "सर्वर व्यस्त है",
        "timeOut": "समय समाप्त हो गया"
    },
    "menu": {
        "home": "मुख्य पृष्ठ",
        "template": "टेम्पलेट प्रबंधन",
        "program": "कार्यक्रम प्रबंधन",
        "playplan": "प्ले प्लान",
        "device": "डिवाइस प्रबंधन",
        "source-material": "सामग्री प्रबंधन",
        "material": "सामग्री",
        "checkManage": "ऑडिट प्रबंधन",
        "setting": "सेटिंग्स",
        "usercenter": "उपयोगकर्ता केंद्र",
        "adminManage": "डिवाइस प्रबंधन",
        "schedule": "कार्य सूची",
        "capitalassets": "संपत्ति प्रबंधन",
        "modifyPassword": "पासवर्ड संशोधित करें",
        "logout": "लॉग आउट करें",
        "add": "जोड़ें",
        "edit": "संपादित करें",
        "delete": "हटाएं",
        "view": "देखें",
        "menu_1": "मुख्य पृष्ठ",
        "menu_2": "डिवाइस प्रबंधन",
        "menu_3": "संपादित करें (उन्नत सेटिंग्स - सामान्य संपादन - नेटवर्क बदलें)",
        "menu_4": "तत्काल आदेश",
        "menu_5": "संपादित करें (विभाग स्थानांतरित करें)",
        "menu_6": "रणनीति",
        "menu_7": "वॉल्यूम सेटिंग्स",
        "menu_8": "ब्राइटनेस सेटिंग्स",
        "menu_9": "डाउनलोड सेटिंग्स",
        "menu_10": "नींद की सेटिंग्स",
        "menu_11": "डिवाइस गुण",
        "menu_12": "संपादित करें/जोड़ें",
        "menu_13": "प्रोग्राम प्रबंधन",
        "menu_14": "प्रकाशन इतिहास",
        "menu_15": "हटाएं (बैच/एकल)",
        "menu_16": "प्रकाशन में प्रोग्राम",
        "menu_17": "समूहीकरण",
        "menu_19": "प्रोग्राम सूची",
        "menu_20": "सामग्री संपादन",
        "menu_21": "प्रोग्राम कॉपी",
        "menu_23": "प्रोग्राम प्रकाशित करें",
        "menu_24": "सामग्री प्रबंधन",
        "menu_25": "अपलोड",
        "menu_28": "त्वरित प्रकाशन",
        "menu_29": "टेम्पलेट प्रबंधन",
        "menu_30": "सार्वजनिक टेम्पलेट",
        "menu_31": "अभी उपयोग करें",
        "menu_32": "मेरे टेम्पलेट",
        "menu_33": "सार्वजनिक टेम्पलेट में प्रकाशित करें",
        "menu_35": "साझा इतिहास",
        "menu_36": "ऑडिट प्रबंधन",
        "menu_37": "प्रोग्राम ऑडिट",
        "menu_38": "ऑडिट (अनुमोदन/अस्वीकार)",
        "menu_39": "सामग्री ऑडिट",
        "menu_41": "ऑडिट इतिहास (ऑपरेटर)",
        "menu_42": "ऑडिट इतिहास (ऑडिटर)",
        "menu_43": "अनुमोदन संख्या देखें",
        "menu_44": "संगठन प्रबंधन",
        "menu_45": "लॉग प्रबंधन",
        "menu_46": "प्लेबैक लॉग",
        "menu_47": "प्रकाशन लॉग",
        "menu_48": "त्रुटि लॉग",
        "menu_49": "ऑपरेशन लॉग",
        "menu_50": "फ़ाइल लॉग",
        "menu_51": "लॉगइन लॉग",
        "menu_52": "सामग्री अनुमोदन",
        "menu_53": "स्टोरेज स्पेस",
        "menu_54": "संगठनात्मक संरचना",
        "menu_55": "भूमिका अधिकार",
        "menu_56": "अधिकृतकरण",
        "menu_57": "देखें (अधिकृतकरण अधिकार)",
        "menu_58": "संगठन सदस्य",
        "menu_60": "उपयोगकर्ता पासवर्ड को रीसेट करें",
        "menu_61": "संपत्ति प्रबंधन",
        "menu_62": "मेरा बैलेंस",
        "menu_63": "देखें (फंड विवरण)",
        "menu_64": "मेरा डेटा उपयोग",
        "menu_65": "देखें (डेटा उपयोग विवरण)",
        "menu_66": "डेटा उपयोग खरीदें",
        "menu_67": "मेरी क्षमता",
        "menu_68": "मेरे डिवाइस",
        "menu_69": "आदेश विवरण",
        "menu_70": "देखें (रिचार्ज)",
        "menu_71": "देखें (खरीदे गए टेम्पलेट)",
        "menu_72": "देखें (खरीदा हुआ डेटा उपयोग)",
        "menu_73": "अन्य अधिकार",
        "menu_74": "देखें (सामग्री और प्रोग्राम सांख्यिकी)",
        "menu_75": "देखें (संपत्ति)",
        "menu_76": "देखें (क्लाउड डेटा उपयोग/सांख्यिकी)",
        "menu_77": "देखें (ऑनलाइन डिवाइस सांख्यिकी)"
    },
    "login": {
        "terminalServiceSystem": "स्मार्ट टर्मिनल सेवा प्रणाली",
        "accountLogin": "खाता लॉगिन",
        "register": "पंजीकरण",
        "accountLoginTip": "पहले से मौजूद खाते से लॉगिन करें",
        "scanQRCode": "कृपया क्यूआर कोड स्कैन करें",
        "readAndAgree": "मैंने पढ़ा है और सहमत हूं",
        "readAndAgreeLink": "उपयोगकर्ता सेवा समझौता",
        "readAndAgreeAgreement": "कृपया उपयोगकर्ता सेवा समझौते को पढ़ें और सहमत हों",
        "forgetpassword": "पासवर्ड भूल गए?",
        "resetpassword": "पासवर्ड रीसेट करें",
        "phoneEmptyTip": "कृपया मोबाइल नंबर दर्ज करें",
        "nextStep": "अगला चरण",
        "title": "लॉगिन के लिए स्वागत है",
        "submit": "लॉगिन",
        "userName": "खाता",
        "password": "पासवर्ड",
        "userNameEmptyTip": "कृपया खाता दर्ज करें",
        "passwordEmptyTip": "कृपया पासवर्ड दर्ज करें",
        "passwordFormatTip": "कृपया सही पासवर्ड प्रारूप दर्ज करें",
        "passwordIsOk": "कृपया पुष्टि पासवर्ड दर्ज करें",
        "passwordSign": "कृपया पासवर्ड दर्ज करें",
        "codeTip": "कृपया सत्यापन कोड दर्ज करें",
        "phone": "मोबाइल नंबर खाली नहीं हो सकता",
        "code": "सत्यापन कोड खाली नहीं हो सकता",
        "nickname": "कंपनी का नाम खाली नहीं हो सकता",
        "pass": "पासवर्ड खाली नहीं हो सकता",
        "pwdMessage": "पासवर्ड की लंबाई 8~20 वर्ण होनी चाहिए, इसमें स्पेस नहीं होना चाहिए और इसमें बड़े अक्षर, छोटे अक्षर, संख्याएं, विशेष वर्णों में से 3 प्रकार शामिल होने चाहिए",
        "pwdMessage01": "कृपया आठ अंकों से अधिक का पासवर्ड अक्षर और संख्या का संयोजन दर्ज करें",
        "pwdMessage02": "पासवर्ड की लंबाई 8-20 वर्ण",
        "pwdMessage03": "पासवर्ड में स्पेस नहीं हो सकता",
        "pwdMessage04": "पासवर्ड में बड़े अक्षर, छोटे अक्षर, संख्याएं, सymbol में से तीन प्रकार शामिल होने चाहिए",
        "newpassempty": "नया पासवर्ड खाली नहीं हो सकता",
        "newpass": "दो बार पासवर्ड असंगत है",
        "getcode": "सत्यापन कोड प्राप्त करें",
        "format": "मोबाइल नंबर का प्रारूप गलत है",
        "chongfa": "सेकंड के बाद फिर से भेजें",
        "isSend": "भेज दिया गया है",
        "noregister": "कोई खाता नहीं? तुरंत पंजीकरण करें",
        "Mobile": "मोबाइल नंबर",
        "verificationcode": "सत्यापन कोड",
        "petname": "उपनाम",
        "Quickregistration": "त्वरित पंजीकरण",
        "xiugaimima": "पासवर्ड संशोधित करें",
        "jiumima": "पुराना पासवर्ड",
        "xinmima": "नया पासवर्ड",
        "zaicishuruxinmima": "फिर से नया पासवर्ड दर्ज करें",
        "xiugaichenggong": "संशोधन सफल",
        "xiugaishoujihao": "मोबाइल नंबर संशोधित करें",
        "dengluzhanghao": "लॉगिन खाता",
        "gongsiid": "कंपनी आईडी",
        "yonghunicheng": "उपयोगकर्ता उपनाम",
        "chuangjianshijian": "निर्माण समय",
        "gongsimingcheng": "कंपनी का नाम",
        "denglumima": "लॉगिन पासवर्ड",
        "jianyi": "पासवर्ड के लिए अक्षर संख्या संयोजन का उपयोग करने की सलाह दी जाती है",
        "shezhimima": "पासवर्ड सेट करें",
        "shezhishoujihao": "मोबाइल नंबर संशोधित/सेट करें",
        "yibangding": "बांध दिया गया है",
        "weibangding": "बांधा नहीं गया",
        "zhanghuanquan": "खाता सुरक्षा",
        "yonghuxinxi": "उपयोगकर्ता की जानकारी",
        "zhuceSucMsg": 'बधाई हो, पंजीकरण सफल!',
        "verificationcodeSucMsg": "सत्यापन कोड सफलतापूर्वक भेजा गया है！",
        "requiredIsEmpty": "आवश्यक फ़ील्ड खाली नहीं हो सकता！",
        "emailObj": {
            "title": 'ईमेल',
            "tit": 'ईमेल लॉगिन',
            "tip": 'कृपया ईमेल पता दर्ज करें',
            "formatTip": 'कृपया सही ईमेल प्रारूप दर्ज करें'
        },
        "phoneObj": {
            "title": 'मोबाइल नंबर',
            "tit": 'मोबाइल लॉगिन',
            "tip": 'कृपया मोबाइल नंबर दर्ज करें',
            "formatTip": 'कृपया सही मोबाइल नंबर प्रारूप दर्ज करें'
        },
        "emailOrPhoneObj": {
            "title": 'ईमेल या मोबाइल नंबर',
            "tit": 'ईमेल या मोबाइल नंबर लॉगिन',
            "tip": 'कृपया ईमेल या मोबाइल नंबर दर्ज करें',
            "formatTip": 'कृपया सही ईमेल या मोबाइल नंबर प्रारूप दर्ज करें'
        },
        "wechatObj": {
            "title": 'व्हाट्सएप',
            "tit": 'व्हाट्सएप लॉगिन'
        },
        "googleObj": {
            "title": 'गूगल',
            "tit": 'गूगल लॉगिन'
        },
        "confirm": 'निश्चित करें',
        "confirmSubmit": 'जमा करने के लिए पुष्टि करें',
        "cancel": 'रद्द करें',
        "close": 'बंद करें',
        "bindSucMsg": 'बंधन सफल',
        "toContinueBindAccount": 'तीसरे पक्ष के खाते को बांधने को पूरा करने के लिए जारी रखें',
        "bindTip01": 'कोई खाता नहीं? एक पंजीकरण करें',
        "bindTip02": 'पहले से मौजूद खाता',
        "bindTip03": 'वर्तमान तीसरे पक्ष का खाता प्लेटफार्म खाते से बांधा नहीं गया है, कृपया मौजूदा खाते को बांधें या नया खाता पंजीकृत करें और बांधें, अगली बार त्वरित लॉगिन कर सकते हैं।',
        "bindTip04": 'मौजूदा खाते को बांधें',
        "bindTip05": 'नया खाता पंजीकृत करें और बांधें',
        "bindTip06": 'आपने तीसरे पक्ष से प्राधिकरण प्राप्त किया है, बंधन को पूरा करने के लिए निम्नलिखित लॉगिन जानकारी को पूरा करें',
        "bindSubmit": 'बंधन जमा करें',
        "enterAccountTip": 'कृपया खाता नाम दर्ज करें',
        "RegisterAndBind": 'पंजीकरण करें और बांधें',
        "loginErr": 'उपयोगकर्ता नाम या पासवर्ड गलत है！',
        "usercenter": "उपयोगकर्ता केंद्र",
        "pleaseInputName": "कृपया नाम दर्ज करें",
        "operationSuccess": "ऑपरेशन सफल हुआ！",
        "edit": "संपादित करें",
        "xiugai": "संशोधित करें",
        "userData": "व्यक्तिगत जानकारी",
        "changePassword": "पासवर्ड संशोधन",
        "account": "खाता",
        "userName01": "उपयोगकर्ता नाम",
        "phoneNumber": "मोबाइल नंबर",
        "role": "भूमिका",
        "createTime": "निर्माण समय",
        "genghuang": "बदलें",
        "bangding": "बांधें",
        "unbind": "बंधन हटाएं",
        "plesaseSelectBindingType": "कृपया बंधन प्रकार का चयन करें",
        "pleaseConfirmCont": "कृपया पुष्टि करें कि मैंने इस सामग्री को पढ़ा है",
        "confirmReadCont": "मैंने इस सामग्री को पढ़ा है",
        "frequentTip": "ऑपरेशन बहुत बार हो रहा है, कृपया बाद में फिर से प्राप्त करें!",
        "zhuxiaoBtn": "खाता रद्द करें",
        "zhuxiaoTitle": "खाता रद्दीकरण",
        "querenZhuxiao": "रद्दीकरण की पुष्टि करें",
        "jiXu": "जारी रखें",
        "sendCodeBtn": "सत्यापन कोड भेजें",
        "passwordIsNotOldPassword": "पुष्टि पासवर्ड नया पासवर्ड के साथ अलग है",
        "passwordIsOldPassword": "संशोधित पासवर्ड मूल पासवर्ड के समान है",
        "passFormatError": "कृपया सही पासवर्ड प्रारूप दर्ज करें",
        "oldPassWord": "मूल पासवर्ड",
        "newPassWord": "नया पासवर्ड",
        "inputPlaceholder": 'कृपया दर्ज करें',
        "confirmPassword": "पुष्टि पासवर्ड",
        "zhuxiaoTip": `
            1、खाता रद्दीकरण एक अपरिवर्तनीय ऑपरेशन है, एक बार खाता रद्द हो जाने के बाद, आप इस खाते से लॉगिन और उपयोग नहीं कर सकेंगे या इस खाते के माध्यम से पंजीकृत तीसरे पक्ष के खाते से लॉगिन नहीं कर सकेंगे, कृपया स्वयं खाता से संबंधित जानकारी और डेटा का बैकअप लें।
            2、इस खाते को पंजीकृत करने से पहले, कृपया सुनिश्चित करें कि सभी संपत्तियां आदि खाली हैं और कोई विवाद नहीं है; एक बार इस खाते को रद्द कर दिया जाए, तो यह आपके द्वारा इस खाते के भीतर की सभी संपत्तियों और अधिकारों के स्वामित्व को छोड़ देने के रूप में माना जाएगा, और इसे पुनर्प्राप्त या खोजना असंभव होगा।
            3、एक ही मोबाइल नंबर से पंजीकृत खाते का कुल 3 बार रद्दीकरण होने के बाद, वह मोबाइल नंबर फिर से नया खाता पंजीकृत नहीं कर सकेगा, साथ ही किसी अन्य खाते से भी बांधा नहीं जा सकेगा।
            `
    },
    "home": {
        "title": "मुख्य पृष्ठ",
        "quickOperation": "त्वरित संचालन",
        "addDevice": "डिवाइस जोड़ें",
        "publishProgram": "कार्यक्रम प्रकाशित करें",
        "publishMaterial": "सामग्री प्रकाशित करें",
        "makeProgram": "कार्यक्रम बनाएं",
        "uploadMaterial": "सामग्री अपलोड करें",
        "todayData": "आज का डेटा (प्रति घंटा अपडेट)",
        "playNumChart": "प्ले बारी सांख्यिकी",
        "deviceOnlineStatus": "डिवाइस ऑनलाइन स्थिति",
        "onLineDevice": "ऑनलाइन डिवाइस",
        "unLineDevice": "ऑफलाइन डिवाइस",
        "programPlayTime": "कार्यक्रम प्ले समय सांख्यिकी",
        "downloadSoft": "सॉफ्टवेयर डाउनलोड",
        "adminApp": "मोबाइल उपयोगकर्ता टर्मिनल",
        "playerApp": "सूचना प्रकाशन प्ले टर्मिनल",
        "downloadAdminApp": "उपयोगकर्ता टर्मिनल डाउनलोड करने के लिए क्लिक करें",
        "downloadPlayerApp": "प्ले टर्मिनल डाउनलोड करने के लिए क्लिक करें",
        "aboutUs": "हमारे बारे में",
        "userManual": "उपयोगकर्ता मैनुअल",
        "message": "मैं संदेश छोड़ना चाहता हूं"
    },
    "device": {
        "inputPlaceholder": 'कृपया दर्ज करें',
        "selectPlaceholder": 'कृपया चुनें',
        "osTypeStr": 'टर्मिनल सिस्टम',
        "onLineStatus": 'ऑनलाइन स्थिति',
        "dpi": 'रिजोल्यूशन',
        "companyDeptIdName": 'संबंधित संगठन',
        "deviceGroupIdName": 'संबंधित समूह',
        "editOrMove": 'संपादित करें/स्थानांतरित करें',
        "loanOriginationFee": 'ऋण प्रक्रिया शुल्क',
        "strategyInfoLook": 'रणनीति जानकारी देखें',
        "programLook": 'कार्यक्रम देखें',
        "addEquipments": 'उपकरण जोड़ें',
        "luminanceSet": 'ब्राइटनेस नियंत्रण',
        "terminal": 'टर्मिनल सेटिंग्स',
        "transferCompany": 'विभाग स्थानांतरित करें',
        "releasedProgram": 'कार्यक्रम प्रकाशित करें',
        "screenshot": 'स्क्रीनशॉट',
        "changeGroup": 'समूह बदलें',
        "defaultGroup": "डिफ़ॉल्ट समूह",
        "operation": "संचालन",
        "edit": "संपादित करें",
        "saveEdit": "संपादन सहेजें",
        "add": "जोड़ें",
        "save": "सहेजें",
        "setting": "सेटिंग्स",
        "program": "कार्यक्रम",
        "unbind": "बंधन हटाएं",
        "sleep": "नींद",
        "wakeup": "जगाएं",
        "restart": "पुनरारंभ करें",
        "shutdown": "बंद करें",
        "reportLog": "लॉग रिपोर्ट करें",
        "clearPlayData": "प्ले टर्मिनल डेटा साफ़ करें",
        "offlineWarn": "यह डिवाइस ऑफलाइन हो चुका है, कृपया डिवाइस ऑनलाइन होने के बाद पुनः प्रयास करें！",
        "confirmUnbind": "बंधन हटाने की पुष्टि करें",
        "confirmReset": "साफ़ करने की पुष्टि करें",
        "confirmDelete": "हटाने की पुष्टि करें",
        "delete": "हटाएं",
        "cancelDelete": "हटाने को रद्द करें",
        "confirmResetSuccess": "सफलतापूर्वक साफ़ हो गया",
        "confirm": "निश्चित करें",
        "cancel": "रद्द करें",
        "operationSuccess": "संचालन सफल",
        "unbindSuccess": "बंधन हटाने में सफलता",
        "pleaseSelectDevice": "कृपया डिवाइस का चयन करें",
        "pleaseSelectOnlineDevice": "कृपया ऑनलाइन डिवाइस का चयन करें",
        "confirmMixOperation": "चयनित डिवाइस में ऑफलाइन डिवाइस शामिल हैं, यह सेटिंग ऑफलाइन डिवाइस पर प्रभावी नहीं है, क्या आप ऑपरेशन जारी रखने की पुष्टि करते हैं？",
        "pleaseSelectDate": "कृपया तारीख चुनें",
        "reportSuccess": "रिपोर्टिंग सफल",
        "deviceSetting": "डिवाइस सेटिंग्स",
        "default": "डिफ़ॉल्ट",
        "all": "सभी",
        "deviceList": "डिवाइस सूची",
        "addDevice": "डिवाइस जोड़ें",
        "department": "विभाग संगठन",
        "deviceType": "रिजोल्यूशन",
        "osType": "टर्मिनल सिस्टम",
        "onlineState": "ऑनलाइन स्थिति",
        "online": "ऑनलाइन",
        "offline": "ऑफलाइन",
        "notActive": "सक्रिय नहीं",
        "search": "कृपया कुंजी शब्द दर्ज करें",
        "batchOperation": "बैच संचालन",
        "allDevices": "सभी डिवाइस",
        "deviceAttribute": "डिवाइस विशेषता",
        "selectReportDate": "रिपोर्ट तारीख चुनें",
        "inputName": "कृपया नाम दर्ज करें",
        "inputWidth": "कृपया चौड़ाई दर्ज करें",
        "inputHeight": "कृपया ऊंचाई दर्ज करें",
        "inputResolutionRatio": "कृपया 0 से बड़ा पूर्णांक दर्ज करें！",
        "inputSort": "कृपया क्रम दर्ज करें",
        "serialNum": "क्रमांक",
        "name": "नाम",
        "width": "चौड़ाई",
        "height": "ऊंचाई",
        "resolutionRatio": "रिजोल्यूशन",
        "inputResolutionRatioName": "कृपया रिजोल्यूशन नाम दर्ज करें",
        "sort": "क्रम",
        "personal": "व्यक्तिगत",
        "system": "सिस्टम",
        "type": "प्रकार",
        "systemDefaultSettingUneditable": "सिस्टम डिफ़ॉल्ट सेटिंग्स संपादित नहीं की जा सकती!",
        "systemDefaultSettingUnDeletable": "सिस्टम डिफ़ॉल्ट सेटिंग्स हटाई नहीं जा सकती!",
        "newz": "नया जोड़ा गया",
        "total": "कुल",
        "totalNum": "पंक्तियां",
        "strategyName": "रणनीति का नाम",
        "associatedTerminalNum": "संबद्ध टर्मिनल की संख्या",
        "createTime": "निर्माण समय",
        "pleaseSelectStrategy": "कृपया रणनीति का चयन करें！",
        "onlySelectOneData": "केवल एक डेटा चुन सकते हैं！",
        "downloadStrategy": "रणनीति डाउनलोड करें",
        "inputStrategyName": "कृपया रणनीति का नाम दर्ज करें",
        "luminanceControl": "ब्राइटनेस नियंत्रण",
        "volumeStrategy": "वॉल्यूम रणनीति",
        "saveSuccess": "सफलतापूर्वक सहेजा गया",
        "screenAngle": "स्क्रीन रोटेशन (°)",
        "startTime": "प्रारंभ समय",
        "endTime": "समाप्ति समय",
        "repeat": "दोहराएं",
        "monday": "सोमवार",
        "tuesday": "मंगलवार",
        "wednesday": "बुधवार",
        "thursday": "गुरुवार",
        "friday": "शुक्रवार",
        "saturday": "शनिवार",
        "sunday": "रविवार",
        "everyday": "हर दिन",
        "downloadSpeed": "डाउनलोड गति",
        "inputDownloadSpeed": "कृपया डाउनलोड गति दर्ज करें",
        "operator": "संचालन",
        "pleaseSelectDeleteData": "कृपया हटाए जाने वाले डेटा का चयन करें！",
        "confirmBatchDelete": "क्या आप बैच हटाने की पुष्टि करते हैं？",
        "pleaseInputName": "कृपया नाम दर्ज करें",
        "detailSetting": "विस्तृत सेटिंग्स",
        "weekPlan": "साप्ताहिक योजना",
        "specialDateSetting": "विशेष तारीख सेटिंग्स",
        "weekdayInfo": "सप्ताह का दिन अनिवार्य है!",
        "volumeInfo": "वॉल्यूम अनिवार्य है!",
        "timeError": "समय चयन त्रुटि!",
        "editSuccess": "संपादन ऑपरेशन सफल！",
        "addSuccess": "जोड़ने का ऑपरेशन सफल！",
        "addSpecialPlan": "विशेष रणनीति योजना जोड़ें",
        "downloadSpeedInfo": "डाउनलोड गति:(0 डाउनलोड प्रतिबंधित को दर्शाता है)",
        "pleaseSelectStartTime": "कृपया प्रारंभ समय चुनें",
        "pleaseSelectEndTime": "कृपया समाप्ति समय चुनें",
        "luminanceError": "कृपया सही ब्राइटनेस मान दर्ज करें！",
        "defaultLuminance": "डिफ़ॉल्ट ब्राइटनेस",
        "luminance": "ब्राइटनेस साइज",
        "defaultLuminanceInfo": "डिफ़ॉल्ट ब्राइटनेस(100 सबसे उज्ज्वल को दर्शाता है, 0 सबसे अंधेरे को दर्शाता है)",
        "volume": "वॉल्यूम",
        "saveLuminance": "ब्राइटनेस सहेजें",
        "changeSuccess": "सफलतापूर्वक बदल दिया गया！",
        "changeNetwork": "नेटवर्क बदलें",
        "netName": "नेटवर्क नाम",
        "nameempty": "नेटवर्क नाम खाली नहीं हो सकता",
        "currentNetwork": "वर्तमान नेटवर्क",
        "ipAddress": "IP पता",
        "dailyMode": "हर दिन का मोड",
        "weeklyMode": "साप्ताहिक मोड",
        "turnOnTime": "शुरू करने का समय",
        "turnOffTime": "बंद करने का समय",
        "startSleep": "नींद शुरू करें",
        "endSleep": "नींद समाप्त करें",
        "batchDelInfo": "क्या आप चयनित आइटम को हटाने की पुष्टि करते हैं？",
        "timeCannotBeEmpty": "समय खाली नहीं हो सकता!",
        "startUp": "शुरू करें",
        "shutDown": "बंद करें",
        "volumeSize": "वॉल्यूम साइज",
        "defaultVolume": "डिफ़ॉल्ट वॉल्यूम(100 सबसे बड़ा को दर्शाता है, 0 म्यूट को दर्शाता है)",
        "chooseStartTime": "कृपया प्रारंभ समय चुनें",
        "chooseEndTime": "कृपया समाप्ति समय चुनें",
        "saveVolume": "वॉल्यूम सहेजें",
        "screenRotationUnSaved": "स्क्रीन रोटेशन सहेजा नहीं गया",
        "volumeSettingUnSaved": "वॉल्यूम सेटिंग्स सहेजी नहीं गई",
        "luminanceSettingUnSaved": "ब्राइटनेस सेटिंग्स सहेजी नहीं गई",
        "confirmClosePopup": "क्या आप इस पॉपअप को बंद करने की पुष्टि करते हैं?",
        "volumeSettingSuccess": "वॉल्यूम संशोधन सफल",
        "luminanceSettingSuccess": "ब्राइटनेस संशोधन सफल",
        "advancedSettingUnSaved": "उन्नत सेटिंग्स सहेजी नहीं गई",
        "settingTitle": "टर्मिनल सेटिंग्स",
        "volumeSetting": "वॉल्यूम सेटिंग्स",
        "luminanceSetting": "ब्राइटनेस सेटिंग्स",
        "downloadSetting": "डाउनलोड सेटिंग्स",
        "sleepSetting": "नींद सेटिंग्स",
        "onOffSetting": "समय पर चालू/बंद",
        "screenRotation": "स्क्रीन रोटेशन",
        "namingError": "नामकरण त्रुटि, फ़ाइल नाम में स्पेस नहीं हो सकता！",
        "deleteSuccess": "हटाने में सफलता",
        "deleteFolder": "फ़ोल्डर हटाएं",
        "pleaseInputDeviceName": "कृपया डिवाइस नाम दर्ज करें",
        "pleaseInputDeviceId": "कृपया डिवाइस आईडी दर्ज करें",
        "discoverDevice": "डिवाइस खोजें",
        "deviceId": "डिवाइस आईडी",
        "bound": "बांध दिया गया है",
        "bind": "बांधें",
        "noDevice": "डिवाइस नहीं है",
        "refresh": "रिफ्रेश",
        "manualAdd": "मैन्युअल रूप से जोड़ें",
        "deviceGroup": "डिवाइस वर्गीकरण",
        "pleaseSelectGroup": "कृपया समूह का चयन करें！",
        "deviceName": "डिवाइस नाम",
        "goAdd": "जोड़ने के लिए जाएं",
        "close": "बंद करें",
        "bindCountInsufficient": "बांधने योग्य संख्या अपर्याप्त है, कृपया डिवाइस संख्या को अपग्रेड करने के बाद जोड़ें！",
        "displayNumber": "प्रदर्शन संख्या",
        "groupName": "समूह का नाम",
        "pleaseSelectGroupName": "कृपया समूह नाम भरें！",
        "moveGroup": "समूह स्थानांतरित करें",
        "longitude": "देशांतर",
        "latitude": "अक्षांश",
        "nationality": "राष्ट्रीयता",
        "province": "प्रांत",
        "city": "शहर",
        "county": "जिला",
        "outNetIp": "बाहरी नेटवर्क IP",
        "inNetIp": "आंतरिक नेटवर्क IP",
        "companyName": "कंपनी का नाम",
        "Info": "विवरण",
        "android": "एंड्रॉइड",
        "win": "विंडोज",
        "osVersion": "सिस्टम संस्करण",
        "softwareVersion": "सॉफ्टवेयर संस्करण",
        "diskSize": "डिस्क साइज",
        "useSize": "प्रयुक्त साइज",
        "macAddr": "MAC पता",
        "longitudeLatitudeInfo": "देशांतर और अक्षांश को एक साथ खाली या गैर-खाली होना चाहिए!",
        "terminalName": "टर्मिनल नाम",
        "terminalGroup": "टर्मिनल समूह",
        "reportJournal": "क्या रिपोर्ट किया जाना है",
        "systemVersion": "सिस्टम संस्करण",
        "storageSpace": "भंडारण स्थान",
        "resolution": "रिजोल्यूशन",
        "runningMemory": "रनिंग मेमरी",
        "model": "मॉडल",
        "registerStatus": "पंजीकरण स्थिति",
        "password": "पासवर्ड",
        "passwordInfo": "कृपया 6 से 18 अंकों का शब्द या संख्या दर्ज करें!",
        "group": "समूह",
        "address": "पता",
        "remark": "टिप्पणी",
        "renewalPeriod": "पुनर्नवीनीकरण अवधि",
        "money": "खर्च",
        "latitudeInfo": "कृपया सही अक्षांश दर्ज करें!",
        "totalPayment": "कुल रकम",
        "longitudeInfo": "कृपया सही देशांतर दर्ज करें!",
        "setMeal": "पैकेज",
        "number": "संख्या",
        "programName": "कार्यक्रम का नाम",
        "playStatus": "प्ले स्थिति",
        "playType": "प्ले तरीका",
        "play": "चलाएं",
        "pause": "ठहराएं",
        "playTime": "प्ले समय",
        "programDeleted": "कार्यक्रम हटा दिया गया",
        "playSuccess": "कार्यक्रम को चलाने की व्यवस्था की गई है",
        "pauseSuccess": "ठहराने में सफलता",
        "playCycle": "चक्रीय प्ले",
        "playInsert": "इंसर्ट प्ले",
        "withdrawSuccess": "वापस लेने में सफलता",
        "withdrawInfo": "कृपया पहले वापस लेने के लिए कार्यक्रम का चयन करें！",
        "programBelong": "संबंधित कार्यक्रम",
        "checkAll": "सभी का चयन करें",
        "batchDel": "बैच हटाएं",
        "delConfirm": "क्या आप चयनित आइटम को हटाने की पुष्टि करते हैं？",
        "check": "चयनित",
        "noProgram": "कोई कार्यक्रम नहीं",
        "details": "विवरण",
        "screenshotFail": "स्क्रीनशॉट विफल",
        "policyName": "नीति का नाम",
        "terminalNum": "संबद्ध टर्मिनल की संख्या",
        "powerStrategy": "बिजली रणनीति",
        "pleaseSelectDepartment": "कृपया विभाग का चयन करें！",
        "screenshotControl": "स्क्रीनशॉट नियंत्रण",
        "未激活": "सक्रिय नहीं",
        "已激活": "सक्रिय हो चुका है",
        "未绑定": "बांधा नहीं गया",
        "已绑定": "बांध दिया गया है"
    },
    "programManage": {
        "programList": "कार्यक्रम सूची",
        "publishProgram": "कार्यक्रम प्रकाशन ट्रेसबैक",
        "week1": "सोमवार",
        "week2": "मंगलवार",
        "week3": "बुधवार",
        "week4": "गुरुवार",
        "week5": "शुक्रवार",
        "week6": "शनिवार",
        "week7": "रविवार",
        "monday": "सोमवार",
        "tuesday": "मंगलवार",
        "wednesday": "बुधवार",
        "thursday": "गुरुवार",
        "friday": "शुक्रवार",
        "saturday": "शनिवार",
        "sunday": "रविवार",
        "name": "नाम",
        "preview": "पूर्वावलोकन",
        "playDeviceNum": "प्ले डिवाइस संख्या",
        "copyDeviceCode": "कॉपी करने के लिए क्लिक करें",
        "osType": "सिस्टम प्रकार",
        "playDate": "प्ले तारीख",
        "playWeek": "प्ले सप्ताह",
        "everyday": "हर दिन",
        "start": "शुरू",
        "end": "समाप्त",
        "playOperateStatusStr": "प्रकाशन स्थिति",
        "playDevice": "प्ले डिवाइस",
        "downloadView": "डाउनलोड देखें",
        "publisher": "प्रकाशक",
        "publishTime": "प्रकाशन समय",
        "operation": "संचालन",
        "add": "जोड़ें",
        "groupName": "समूह का नाम",
        "selectDevice": "टर्मिनल चुनें",
        "searchDevice": "टर्मिनल खोजें",
        "pleaseFillGroupName": "कृपया समूह नाम भरें！",
        "remarkInfo": "टिप्पणी",
        "compile": "संपादित करें",
        "withdrawConfirm": "क्या आप इस कार्यक्रम को वापस लेने की पुष्टि करते हैं？",
        "confirm": "निश्चित करें",
        "cancel": "रद्द करें",
        "withdraw": "वापस लें",
        "batchWithdraw": "बैच वापस लें",
        "batchPublish": "बैच प्रकाशित करें",
        "batchDelete": "बैच हटाएं",
        "batchOperation": "बैच संचालन",
        "notUse": "उपयोग नहीं किया गया",
        "notChecked": "जांच नहीं की गई",
        "notPass": "पास नहीं हुआ",
        "delete": "हटाएं",
        "publishTextLeft": "प्रकाशित किया गया",
        "offTextLeft": "ठहरा दिया गया",
        "pleaseSelectProgramToMove": "कृपया स्थानांतरित करने के लिए कार्यक्रम का चयन करें！",
        "pause": "ठहराएं",
        "pauseConfirm": "क्या आप ठहराने की पुष्टि करते हैं？",
        "play": "चलाएं",
        "downloadUdisk": "यूडिस्क डाउनलोड करें",
        "deviceList": "डिवाइस सूची",
        "groupSelection": "समूह चयन",
        "operationSuccess": "संचालन सफल",
        "deleteSuccess": "हटाने में सफलता",
        "selectDate": "तारीख चुनें",
        "publishStatus": "प्रकाशन स्थिति",
        "checkStatus": "जांच स्थिति",
        "waitAuditing": "जांच की प्रतीक्षा में",
        "auditPass": "जांच पास",
        "auditRefuse": "जांच अस्वीकार",
        "all": "सभी",
        "playStatus": "चल रहा है",
        "playStatust": "प्ले स्थिति",
        "pauseStatus": "ठहरा दिया गया",
        "notStartStatus": "शुरू नहीं हुआ",
        "resolutionratio": "रिजोल्यूशन",
        "totalNum": "पंक्तियां",
        "programName": "कार्यक्रम का नाम",
        "playStartTime": "प्ले प्रारंभ समय",
        "playEndTime": "प्ले समाप्ति समय",
        "createTime": "निर्माण समय",
        "nationality": "राष्ट्रीयता",
        "province": "प्रांत",
        "city": "शहर",
        "county": "जिला",
        "address": "पता",
        "ip": "IP पता",
        "location": "स्थान",
        "log": "लॉग",
        "pleaseFillProgramName": "कृपया कार्यक्रम नाम भरें！",
        "selectGroup": "समूह चुनें",
        "startTime": "प्रारंभ समय",
        "endTime": "समाप्ति समय",
        "publishCycle": "प्रकाशन चक्र",
        "publishDeviceNum": "प्रकाशन डिवाइस संख्या",
        "pleaseSelectRecord": "कृपया रिकॉर्ड चुनें",
        "deviceName": "टर्मिनल नाम",
        "deviceId": "टर्मिनल डिवाइस आईडी",
        "deviceGroupIdName": "संबंधित समूह",
        "notClassified": "वर्गीकृत नहीं",
        "osTypeStr": "टर्मिनल सिस्टम",
        "storageSpace": "भंडारण स्थान",
        "onLineStatus": "ऑनलाइन स्थिति",
        "onLine": "ऑनलाइन",
        "offLine": "ऑफलाइन",
        "sleep": "नींद",
        "unknown": "अज्ञात",
        "registerStatus": "पंजीकरण स्थिति",
        "trialPeriod": "परीक्षण अवधि",
        "notActive": "सक्रिय नहीं",
        "active": "सक्रिय हो चुका है",
        "parameterError": "पैरामीटर गलत!",
        "pleaseSelectProgram": "कृपया कार्यक्रम का चयन करें!",
        "pleaseSelectProgramEdit": "कृपया संपादित करने के लिए कार्यक्रम का चयन करें!",
        "confirmWithdrawSelectedProgram": "क्या आप चयनित कार्यक्रम को वापस लेने की पुष्टि करते हैं？",
        "withdrawSuccess": "वापस लेने में सफलता",
        "allPrograms": "सभी कार्यक्रम",
        "defaultGroup": "डिफ़ॉल्ट समूह",
        "cannotShareEmptyProgram": "खाली कार्यक्रम साझा नहीं कर सकते！",
        "onlyShareYourProgram": "केवल आपके द्वारा बनाए गए कार्यक्रम को साझा कर सकते हैं!",
        "pleaseSelectProgramEditPublishTime": "कृपया प्रकाशन समय संपादित करने के लिए कार्यक्रम का चयन करें!",
        "pleaseSelectDevice": "कृपया डिवाइस का चयन करें!",
        "programDetail": "कार्यक्रम विवरण",
        "errorReason": "त्रुटि का कारण",
        "availableStorageSpaceInsufficient": "उपलब्ध भंडारण स्थान अपर्याप्त",
        "partialDeviceReleaseFailure": "आंशिक डिवाइस प्रकाशन विफल",
        "allDeviceReleaseSuccess": "सभी डिवाइस प्रकाशन सफल",
        "partialDeviceReleaseSuccess": "आंशिक डिवाइस प्रकाशन सफल",
        "allGroup": "सभी समूह",
        "allProgram": "सभी कार्यक्रम",
        "unGrouped": "समूहीकृत नहीं",
        "replaceProgram": "कार्यक्रम को बदलें",
        "replaceProgramTip": "नया प्रकाशित कार्यक्रम प्ले टर्मिनल पर पहले से मौजूद कार्यक्रम डेटा को बदल देगा！",
        "screen": "सिंगल/डबल स्क्रीन",
        "singleScreen": "सिंगल स्क्रीन",
        "doubleScreen": "डबल स्क्रीन",
        "playSetting": "प्ले सेटिंग्स",
        "batchPlaySetting": "बैच प्ले समय सेट करें",
        "individualPlaySetting": "एक-एक करके प्ले समय सेट करें",
        "playTime": "प्ले समय",
        "daily": "हर दिन",
        "weekdays": "सोमवार से शुक्रवार",
        "monthly": "वर्तमान माह",
        "advancedSetting": "उन्नत सेटिंग्स",
        "playProgram": "कार्यक्रम चलाएं",
        "searchProgram": "कृपया कुंजी शब्द दर्ज करें",
        "shareAddressNotExist": "लिंक पता मौजूद नहीं है, कृपया पुनः प्रयास करें",
        "copySuccess": "कॉपी सफल",
        "shareLink": "साझा लिंक",
        "publish": "प्रकाशित करें",
        "noResource": "संसाधन नहीं है",
        "single": "सिंगल स्क्रीन",
        "double": "डबल स्क्रीन",
        "time": "समय",
        "associatedTerminalNum": "संबद्ध टर्मिनल की संख्या",
        "default": "डिफ़ॉल्ट",
        "moveGroup": "समूह स्थानांतरित करें",
        "pleaseSelectGroup": "कृपया समूह नाम भरें！",
        "copy": "कॉपी करें",
        "FUBEN": "कॉपी",
        "nameempty": "नाम खाली नहीं हो सकता",
        "whitespace": "नामकरण त्रुटि, फ़ाइल नाम में स्पेस नहीं हो सकता！",
        "programWhitespace": "नामकरण त्रुटि, कार्यक्रम नाम में स्पेस नहीं हो सकता！",
        "pleaseSelectResolution": "कृपया रिजोल्यूशन का चयन करें！",
        "dataError": "डेटा गलत！",
        "createProgram": "नया कार्यक्रम बनाएं",
        "directCreate": "प्रत्यक्ष रूप से बनाएं",
        "myTemplate": "मेरा टेम्पलेट",
        "use": "उपयोग करें",
        "free": "मुफ्त",
        "loadMore": "और लोड करें",
        "confirmDelete": "हटाने की पुष्टि करें",
        "deleteGroup": "समूह हटाएं",
        "notPublished": "प्रकाशित नहीं किया गया",
        "notPassed": "पास नहीं हुआ",
        "notUsed": "उपयोग नहीं किया गया",
        "confirmDeleteSelectedProgram": "क्या आप चयनित कार्यक्रम को हटाने की पुष्टि करते हैं？",
        "companyName": "कंपनी का नाम",
        "programCannotDownload": "यह कार्यक्रम डाउनलोड नहीं किया जा सकता！",
        "publishMaterial": "सामग्री प्रकाशित करें",
        "playMaterial": "सामग्री चलाएं",
        "pleaseInputMaterialName": "कृपया सामग्री नाम दर्ज करें",
        "size": "साइज",
        "pleaseInputDeviceName": "कृपया डिवाइस नाम दर्ज करें",
        "item": "पंक्तियां",
        "allMaterial": "सभी सामग्री",
        "allDevices": "सभी डिवाइस",
        "saveSuccess": "सहेजने में सफलता हुई",
        "savefaill": "सहेजने में विफलता हुई",
        "playMode": "चलाने का तरीका",
        "cyclePlay": "चक्रीय प्ले",
        "insertPlay": "इंसर्ट प्ले",
        "noData": "कोई डेटा नहीं",
        "Add": "नया जोड़ें",
        "replace": "प्रतिस्थापित करें",
        "repeat": "दोहराएं",
        "start01": "शुरू",
        "end01": "समाप्त",
        "startDate": "शुरुआती तारीख",
        "endDate": "समाप्ति तारीख",
        "useNow": "तुरंत उपयोग करें",
        "fillStartEndTimeFirst": "जोड़ने से पहले शुरुआती और समाप्ति समय भरें",
        "fillFullPlayTime": "पूर्ण प्ले समय भरें",
        "fillCorrectPlayTime": "सही प्ले समय अवधि भरें",
        "sDateAndEDateBothEmptyOrFilled": "शुरुआती तारीख और समाप्ति तारीख को या तो दोनों खाली रखें या दोनों भरें"
    },
    "source": {
        "addResource": "संसाधन जोड़ें",
        "width": "चौड़ाई",
        "height": "ऊंचाई",
        "size": "आकार (KB)",
        "name": "नाम",
        "pleaseInputResourceName": "कृपया संसाधन का नाम दर्ज करें！",
        "addToGroup": "समूह में जोड़ें",
        "remark": "टिप्पणी",
        "promptFgIllustrate": "चित्रण",
        "promptFgRealisticPhoto": "वास्तववादी फोटो",
        "promptFgSimplisticDrawing": "सरल चित्र",
        "promptFgChineseStyle": "चीनी शैली",
        "promptFgPixelArt": "पिक्सल शैली",
        "noModel": "कोई मॉडल नहीं है, कृपया प्रशासक से संपर्क करें！",
        "getModelFailed": "मॉडल प्राप्त करने में विफलता, कृपया बाद में पुनः प्रयास करें！या प्रशासक से संपर्क करें！",
        "createImagePrompt": "चित्र बनाया जा रहा है, कृपया बाद में बंद करें！",
        "promptEmpty": "कृपया प्रॉम्प्ट शब्द दर्ज करें",
        "dpiEmpty": "कृपया चित्र अनुपात चुनें！",
        "fgEmpty": "कृपया शैली चुनें！",
        "style": "शैली",
        "idEmpty": "चित्र आईडी खाली नहीं हो सकता",
        "exist": "यह चित्र सामग्री में पहले से मौजूद है",
        "addSuccess": "सामग्री जोड़ने में सफलता",
        "saveError": "चित्र सहेजने में विफलता, कृपया बाद में पुनः प्रयास करें！",
        "delSuccess": "हटाने में सफलता",
        "generateImage": "टेक्स्ट से इमेज",
        "generateImagePlaceholder": 'कृपया वह चित्र दर्ज करें जिसे आप बनाना चाहते हैं, जैसे: एक तितली फूलों के मैदान में नृत्य कर रही है',
        "aiExpand": "स्मार्ट विस्तार",
        "negativePrompt": "नकारात्मक प्रॉम्प्ट",
        "negativePromptTooltip": "उस सामग्री या विशेषताओं को स्पष्ट रूप से निकालने के लिए उपयोग किया जाता है जिसे उपयोगकर्ता आउटपुट में नहीं देखना चाहता",
        "imageRatio": "चित्र अनुपात",
        "generateImageBtn": "तुरंत उत्पन्न करें",
        "shengchengjieguo": "उत्पन्न परिणाम",
        "generateImageLoadingTip": "उत्पन्न हो रहा है, कृपया दोहराएं क्लिक या बंद न करें...",
        "Tooltip": "अपनी रचनात्मकता को AI से बनाएं",
        "saveToMaterial": "सामग्री में सहेजें",
        "publish": "तुरंत प्रकाशित करें",
        "download": "डाउनलोड करें",
        "generateHistory": "उत्पन्न इतिहास",
        "hide": "संक्षिप्त करें",
        "cancel": "रद्द करें",
        "useExpand": "विस्तार का उपयोग करें",
        "all": "सभी",
        "delete": "हटाएं",
        "loadMore": "और लोड करें",
        "aiTip": "सामग्री कृत्रिम बुद्धिमत्ता मॉडल द्वारा उत्पन्न की गई है, यह प्लेटफार्म के विचारों, रुख या रवैये का प्रतिनिधित्व नहीं करती है, कृपया AI सामग्री का उपयोग उचित और कानूनी तरीके से करें",
        "operationSuccess": "संचालन सफल",
        "moveGroup": "समूह स्थानांतरित करें",
        "groupName": "समूह का नाम",
        "pleaseSelectGroup": "कृपया समूह का नाम चुनें！",
        "shenhe": "जांच",
        "shenheStatus": "जांच की स्थिति",
        "shenheSuccess": "जांच पास",
        "shenheRefuse": "जांच अस्वीकार",
        "pleaseSelectShenheStatus": "कृपया जांच की स्थिति चुनें！",
        "shenheRemark": "जांच टिप्पणी",
        "pleaseInputShenheRemark": "कृपया जांच टिप्पणी दर्ज करें！",
        "pleaseInputFileName": "कृपया फ़ाइल नाम दर्ज करें！",
        "whitespace": "नामकरण त्रुटि, फ़ाइल नाम में स्पेस नहीं हो सकता！",
        "dataError": "डेटा गलत！",
        "confirmDelete": "हटाने की पुष्टि करें",
        "confirm": "निश्चित करें",
        "deleteFolder": "फ़ोल्डर हटाएं",
        "add": "जोड़ें",
        "edit": "संपादित करें",
        "fileName": "फ़ाइल नाम",
        "group": "समूह",
        "resolution": "रिजोल्यूशन",
        "type": "प्रकार",
        "image": "चित्र",
        "music": "संगीत",
        "video": "वीडियो",
        "uploadTime": "अपलोड समय",
        "uploadUser": "अपलोड करने वाला",
        "checkTime": "जांच समय",
        "checkUser": "जांच करने वाला"
    },
    "setting": {
        "nameempty": "नाम खाली नहीं हो सकता",
        "heightempty": "ऊंचाई खाली नहीं हो सकती",
        "widthempty": "चौड़ाई खाली नहीं हो सकती",
        "resolutionratio": "रिजोल्यूशन",
        "name": "नाम",
        "opteration": "संचालन",
        "compile": "संपादित करें",
        "delete": "हटाएं",
        "newz": "नया जोड़ा गया",
        "compileratio": "रिजोल्यूशन संपादित करें",
        "sheizhifenbianlvmingcheng": "रिजोल्यूशन नाम सेट करें",
        "shezhigaodu": "ऊंचाई सेट करें",
        "shezhikuandu": "चौड़ाई सेट करें",
        "xinzengfenbianlv": "नया रिजोल्यूशन जोड़ें",
        "bianma": "कोडिंग",
        "bianjizhongduanmingcheng": "टर्मिनल नाम संपादित करें",
        "xinzengzhongduan": "नया टर्मिनल जोड़ें",
        "selectPrimaryColor": 'थीम रंग चुनें',
        "fullScreen": 'पूर्ण स्क्रीन',
        "exitFullScreen": 'पूर्ण स्क्रीन से बाहर निकलें'
    },
    "tabs": {
        "refresh": 'रिफ्रेश',
        "refreshAll": 'सभी को रिफ्रेश करें',
        "close": 'बंद करें',
        "closeOthers": 'अन्य को बंद करें',
        "closeAll": 'सभी को बंद करें',
        "closeLeft": 'बाएं ओर को बंद करें',
        "closeRight": 'दाएं ओर को बंद करें'
    },
    "errorPage": {
        "needLogin": 'आप अभी तक लॉगिन नहीं किया है！',
        "pageNotFound": 'आपके द्वारा एक्सेस किया गया पृष्ठ मौजूद नहीं है！',
        "redirectTo": 'रीडायरेक्ट हो रहा है',
        "orReturn": 'या वापस लौटें',
        "previousStep": 'पिछला चरण'
    },
    "headerUs": {
        "systemNotice": "सिस्टम सूचना",
        "allNotices": "सभी सूचनाएं",
        "viewAllMessages": "सभी संदेश देखें",
        "contactUs": "हमसे संपर्क करें",
        "operationSuccess": "संचालन सफल！",
        "leaveMessage": "मैं संदेश छोड़ना चाहता हूं",
        "messageTitle": "शीर्षक",
        "messageTitleTip": "कृपया शीर्षक दर्ज करें！",
        "messageContentTip": "150 शब्दों के भीतर",
        "submit": "जमा करें",
        "markAsRead": "पढ़ा हुआ के रूप में चिह्नित करें",
        "success": "संचालन सफल！"
    },
    "material": {
        "allMaterial": "सभी सामग्री",
        "defaultGroup": "डिफ़ॉल्ट समूह",
        "auditStatus": "जांच की स्थिति",
        "auditPassed": "जांच पास",
        "auditRejected": "जांच अस्वीकार",
        "pendingAudit": "जांच की प्रतीक्षा में",
        "all": "सभी",
        "operateSuccess": "संचालन सफल！",
        "pleaseSelectMaterial": "कृपया सामग्री चुनें！",
        "moveGroup": "समूह स्थानांतरित करें",
        "pleaseSelectGroup": "कृपया समूह चुनें！",
        "batchPublish": "बैच प्रकाशित करें",
        "batchRecall": "बैच वापस लें",
        "batchDelete": "बैच हटाएं",
        "materialList": "सामग्री सूची",
        "uploadMaterial": "सामग्री अपलोड करें",
        "materialType": "सामग्री प्रकार",
        "pleaseInputMaterialName": "कृपया सामग्री का नाम दर्ज करें",
        "selectAll": "सभी का चयन करें",
        "confirmDeleteSelectedMaterial": "क्या आप चयनित सामग्री को हटाने की पुष्टि करते हैं？",
        "deleteSuccess": "हटाने में सफलता",
        "delete": "हटाएं",
        "publish": "प्रकाशित करें",
        "recall": "वापस लें",
        "confirmRecallSelectedMaterial": "क्या आप चयनित सामग्री को वापस लेने की पुष्टि करते हैं？",
        "pleaseSelectMaterialGroup": "कृपया सामग्री समूह चुनें！",
        "recallSuccess": "वापस लेने में सफलता",
        "publishSuccess": "प्रकाशन में सफलता",
        "batchOperate": "बैच संचालन",
        "item": "पंक्तियां",
        "confirmDelete": "क्या आप हटाने की पुष्टि करते हैं？",
        "edit": "संपादित करें",
        "confirmRecall": "क्या आप वापस लेने की पुष्टि करते हैं？",
        "unaudited": "जांच नहीं की गई",
        "notPassed": "पास नहीं हुआ",
        "operate": "संचालन",
        "resolution": "रिजोल्यूशन",
        "none": "कुछ भी नहीं",
        "confirm": 'निश्चित करें',
        "cancel": 'रद्द करें',
        "AICreation": "AI निर्माण"
    },
    "uploadFile": {
        "operationSuccess": "संचालन सफल",
        "uploadFile": "अपलोड प्रबंधन",
        "uploadSuccess": "अपलोड सफल",
        "uploadCompleted": "अपलोड पूरा हुआ",
        "uploadFail": "अपलोड विफल",
        "ConversionFailed": "रूपांतरण विफल！",
        "loading": "लोड हो रहा है...",
        "beQueuing": "कतार में...",
        "Uploading": "अपलोड हो रहा है...",
        "ConversionIng": "रूपांतरण हो रहा है...",
        "ConventionalResources": "पारंपरिक संसाधन",
        "DocumentResources": "दस्तावेज़ संसाधन",
        "complete": "पूरा",
        "upload": "अपलोड करें",
        "fileSizeWraning01": "सामग्री का आकार से अधिक",
        "fileSizeWraning02": "कृपया संशोधन के बाद फिर से अपलोड करें！",
        "fileIsEmpty": "फ़ाइल खाली है",
        "uploadFileTip": "समर्थित नहीं फ़ाइल प्रारूप",
        "unablePreview": "सामग्री लाइब्रेरी में सफलतापूर्वक जोड़ा नहीं गया, पूर्वावलोकन नहीं किया जा सकता",
        "confirmDelete": "क्या आप हटाने की पुष्टि करते हैं？",
        "deleteSuccess": "हटाने में सफलता",
        "delete": "हटाएं",
        "confirm": "निश्चित करें",
        "preview": "पूर्वावलोकन",
        "close": "बंद करें",
        "cancel": "रद्द करें",
        "fileType": "फ़ाइल प्रकार",
        "fileSize": "फ़ाइल आकार",
        "conversionProgress": "रूपांतरण प्रगति",
        "progress": "प्रगति",
        "image": "चित्र",
        "video": "वीडियो",
        "audio": "संगीत",
        "limitTip01": "एक बार अपलोड",
        "limitTip02": "फ़ाइलें",
        "okTip": "सामग्री अपलोड की जा रही है, कृपया बाद में बंद करें！",
        "usableSize": 'उपयोग योग्य क्षमता',
        "sizeUnableTip": "वर्तमान उपयोग योग्य भंडारण स्थान अपर्याप्त है, कृपया समय पर बेकार सामग्री को साफ़ करके स्थान बचाएं या डीलर से संपर्क करके क्षमता का विस्तार करें।",
        "view": "विवरण देखें",
        "fileName": "फ़ाइल नाम"
    },
    "template": {
        "inputPlaceholder": 'कृपया दर्ज करें',
        "selectPlaceholder": 'कृपया चुनें',
        "noAuths": "कोई अधिकार नहीं है, कृपया प्रशासक से संपर्क करें",
        "operationSuccess": "संचालन सफल",
        "total": "कुल",
        "totalNum": "पंक्तियां",
        "dan": "एकल",
        "shaung": "दोहरा",
        "pleaseSelectGroup": "कृपया समूह चुनें",
        "preview": "पूर्वावलोकन",
        "free": "मुफ्त",
        "use": "उपयोग करें",
        "dpi": 'रिजोल्यूशन',
        "delete": "हटाएं",
        "confirmDelete": "हटाने की पुष्टि करें",
        "confirmDeleteSelectedTemplate": "क्या आप इस टेम्पलेट को हटाने की पुष्टि करते हैं",
        "push": "प्रकाशित करें",
        "pushConfirm": "क्या आप सार्वजनिक टेम्पलेट में प्रकाशित करने की पुष्टि करते हैं",
        "pushRemovalConfirm": "क्या आप सार्वजनिक टेम्पलेट से हटाने की पुष्टि करते हैं",
        "templateOrderRecord": "टेम्पलेट ऑर्डर रिकॉर्ड",
        "unpublished": "प्रकाशित नहीं किया गया",
        "auditing": "जांच की प्रक्रिया में",
        "publishRejected": "प्रकाशन अस्वीकार",
        "publishSuccess": "प्रकाशन सफल",
        "offShelf": "हटा दिया गया",
        "公共模版": "सार्वजनिक टेम्पलेट",
        "我的模板": "मेरा टेम्पलेट",
        "共享记录": "साझाकरण रिकॉर्ड",
        "name": "नाम",
        "pubdate": "प्रकाशन समय",
        "keySeachTip": "कृपया कुंजी शब्द दर्ज करें",
        "allGroup": "सभी समूह",
        "add": "जोड़ें",
        "edit": "संपादित करें",
        "programName": "कार्यक्रम का नाम",
        "selectGroup": "समूह चुनें"
    },
    "checkManage": {
        "total": "कुल",
        "totalNum": "पंक्तियां",
        "operationSuccess": "संचालन सफल",
        "checkUserLogs": "जांच रिकॉर्ड (ऑपरेटर)",
        "checkLogs": "जांच रिकॉर्ड (ऑडिटर)",
        "sourceCheck": "सामग्री जांच",
        "programCheck": "कार्यक्रम जांच",
        "checkAll": "सभी का चयन करें",
        "auditPass": "जांच पास",
        "auditRefuse": "जांच अस्वीकार",
        "auditPass01": "पास",
        "auditRefuse01": "अस्वीकार",
        "auditRefuse02": "जांच अस्वीकार",
        "auditor": "जांच करने वाला",
        "agentUserName": "प्रकाशक",
        "interrogationTime": "जांच के लिए प्रस्तुत करने का समय",
        "checkTime": "जांच समय",
        "checkName": "जांच का नाम",
        "checkType": "जांच श्रेणी",
        "checkIp": "जांच के लिए प्रस्तुत IP पता",
        "checkReason": "संदेश",
        "checkStatus": "संचालन सामग्री",
        "rangePicker": "जांच तारीख",
        "keyWord": "कुंजी शब्द",
        "all": "सभी",
        "program": 'कार्यक्रम',
        "material": 'सामग्री',
        "dan": "एकल",
        "shaung": "दोहरा",
        "pleaseSelectProgram": "कृपया कार्यक्रम चुनें!",
        "pleaseSelectMaterial": "कृपया सामग्री चुनें！",
        "preview": "पूर्वावलोकन",
        "dpi": 'रिजोल्यूशन',
        "auditRefuseTip": "कृपया अस्वीकार करने का कारण दर्ज करें",
        "unreviewed": "जांच नहीं की गई",
        "notPassed": "पास नहीं हुआ",
        "notUsed": "उपयोग नहीं किया गया",
        "edit": "संपादित करें",
        "none": "कुछ भी नहीं",
        "name": "नाम",
        "size": "आकार",
        "type": "प्रकार",
        "uploadTime": "अपलोड समय",
        "uploadUser": "अपलोड करने वाला",
        "checkUser": "जांच करने वाला",
        "image": "चित्र",
        "music": "संगीत",
        "video": "वीडियो"
    },
    "systemSet": {
        "total": "कुल",
        "totalNum": "पंक्तियां",
        "inputPlaceholder": 'कृपया दर्ज करें',
        "selectPlaceholder": 'कृपया चुनें',
        "userList": "संगठन के सदस्य",
        "roleList": "भूमिका अधिकार",
        "department": "संगठन संरचना",
        "diskInfo": "भंडारण स्थान",
        "approveSet": "सामग्री अनुमोदन",
        "logList": "लॉग प्रबंधन",
        "name": "नाम",
        "account": "खाता",
        "userName": "उपयोगकर्ता का नाम",
        "phoneNumber": "मोबाइल नंबर",
        "role": "भूमिका",
        "createTime": "निर्माण समय",
        "operation": "संचालन",
        "edit": "संपादित करें",
        "delete": "हटाएं",
        "addNew": "नया जोड़ें",
        "add": "जोड़ें",
        "resetPassword": "पासवर्ड रीसेट करें",
        "confirmDelete": "हटाने की पुष्टि करें",
        "departmentOrganization": "विभाग संगठन",
        "addNewUser": "नया उपयोगकर्ता जोड़ें",
        "pleaseEnterUserName": "कृपया उपयोगकर्ता का नाम दर्ज करें",
        "confirmPasswordNotMatch": "पुष्टि पासवर्ड पासवर्ड के साथ मेल नहीं खाता!",
        "operationSuccess": "संचालन सफल！",
        "userNickname": "उपयोगकर्ता का नाम",
        "pleaseEnterUserNickname": "कृपया उपयोगकर्ता का नाम दर्ज करें",
        "userNicknameRequired": "उपयोगकर्ता का नाम खाली नहीं हो सकता！",
        "password": "पासवर्ड",
        "pleaseEnterPassword": "कृपया पासवर्ड दर्ज करें",
        "passwordRequired": "पासवर्ड खाली नहीं हो सकता！",
        "passwordTip": "आपका पासवर्ड बहुत कम सुरक्षित है (पासवर्ड में बड़े अक्षर, छोटे अक्षर, संख्याएं, विशेष वर्णों में से कोई भी 3 प्रकार शामिल होने चाहिए और लंबाई 8 में होनी चाहिए",
        "confirmPassword": "पुष्टि पासवर्ड",
        "pleaseEnterPhoneNumber": "कृपया मोबाइल नंबर दर्ज करें",
        "phoneNumberRequired": "मोबाइल नंबर खाली नहीं हो सकता！",
        "phoneNumberFormatError": "कृपया सही मोबाइल नंबर दर्ज करें！",
        "roleRequired": "भूमिका खाली नहीं हो सकती！",
        "required": "खाली नहीं हो सकता！",
        "departmentName": "विभाग",
        "modifyPassword": "पासवर्ड संशोधित करें",
        "newPassword": "नया पासवर्ड",
        "pleaseEnterNewPassword": "कृपया नया पासवर्ड दर्ज करें",
        "pwdMessage": "पासवर्ड की लंबाई 8~20 वर्ण होनी चाहिए, इसमें स्पेस नहीं होना चाहिए और इसमें बड़े अक्षर, छोटे अक्षर, संख्याएं, विशेष वर्णों में से 3 प्रकार शामिल होने चाहिए",
        "all": "सभी",
        "noAuths": "कोई अधिकार नहीं है, कृपया प्रशासक से संपर्क करें",
        "departmentName01": "विभाग का नाम",
        "image": "चित्र",
        "music": "संगीत",
        "video": "वीडियो",
        "buySize": "खरीद संख्या",
        "totalMoney": "शुल्क राशि",
        "buycreateTime": "खरीद समय",
        "endTime": "समाप्ति समय",
        "buyTypeStr": "ऑर्डर प्रकार",
        "sourceCheck": "सामग्री जांच",
        "programCheck": "कार्यक्रम जांच",
        "programName": "कार्यक्रम का नाम",
        "diskExpansion": "उपयोग के दौरान समय पर समाप्त/अनुपयोगी सामग्री को साफ़ करने की सलाह दी जाती है, ताकि सिस्टम की उपयोग योग्य क्षमता सुनिश्चित हो सके। यदि आपको अधिक स्थान की आवश्यकता है, तो आप अपने डिवाइस आपूर्तिकर्ता से क्लाउड भंडारण स्थान की क्षमता विस्तार सेवा प्राप्त कर सकते हैं। इस सेवा से खर्च आ सकता है, विवरण के लिए डीलर की जानकारी का पालन करें।",
        "selectPermission": "कृपया अधिकार चुनें",
        "checkPermission": "कृपया अधिकार को चेक करें",
        "addRole": "भूमिका जोड़ें",
        "enterRoleName": "कृपया भूमिका का नाम दर्ज करें",
        "roleName": "भूमिका का नाम",
        "roleNameRequired": "भूमिका का नाम खाली नहीं हो सकता！",
        "remark": "टिप्पणी",
        "enterRemark": "कृपया टिप्पणी दर्ज करें",
        "permissionSetting": "अधिकार सेटिंग्स",
        "deleteSuccess": "हटाने में सफलता！",
        "confirmToDelete": "क्या आप हटाने की पुष्टि करते हैं？",
        "orgName": "संगठन का नाम",
        "orgNameRequired": "संगठन का नाम खाली नहीं हो सकता！",
        "orgRemark": "संगठन टिप्पणी",
        "enterOrgRemark": "कृपया संगठन टिप्पणी दर्ज करें",
        "capacityUsage": "क्षमता उपयोग स्थिति",
        "usedCapacity": "प्रयुक्त क्षमता",
        "totalCapacity": "कुल क्षमता",
        "remainingCapacity": "शेष क्षमता",
        "capacityExpansion": "क्षमता विस्तार",
        "enable": "चालू",
        "disable": "बंद",
        "userName01": "उपयोगकर्ता नाम",
        "loginTime": "लॉगिन समय",
        "ipAddress": "IP पता",
        "loginResult": "लॉगिन परिणाम",
        "selectDate": "तारीख चुनें",
        "enterDate": "कृपया तारीख चुनें",
        "selectStartTime": "कृपया प्रारंभ समय चुनें",
        "selectEndTime": "कृपया समाप्ति समय चुनें",
        "enterUserName": "कृपया उपयोगकर्ता नाम दर्ज करें",
        "userCount": "उपयोगकर्ता संख्या",
        "roleDesc": "भूमिका विवरण",
        "roleAuthorization": "भूमिका प्राधिकरण",
        "success": "सफल",
        "failure": "विफल",
        "time": "समय",
        "operationContent": "संचालन सामग्री",
        "playCount": "प्ले बारी",
        "playDuration": "प्ले अवधि",
        "selectDevice": "डिवाइस चुनें",
        "enterProgramName": "कृपया कार्यक्रम का नाम दर्ज करें",
        "serialNumber": "क्रमांक",
        "publishContentName": "प्रकाशन सामग्री का नाम",
        "playMode": "प्ले तरीका",
        "cyclePlay": "चक्रीय प्ले",
        "insertPlay": "इंसर्ट प्ले",
        "paddingPlay": "पैड प्ले",
        "playDeviceId": "प्ले डिवाइस आईडी",
        "playDeviceName": "प्ले डिवाइस नाम",
        "publishTime": "प्रकाशन समय",
        "downloadStatus": "डाउनलोड स्थिति",
        "notDownloaded": "डाउनलोड नहीं किया गया",
        "downloading": "डाउनलोड हो रहा है",
        "downloadSucceeded": "डाउनलोड सफल",
        "downloadFailed": "डाउनलोड विफल",
        "enterPublishContentName": "कृपया प्रकाशन सामग्री का नाम दर्ज करें",
        "terminalId": "टर्मिनल आईडी",
        "belongOrg": "संबंधित संगठन",
        "reportTime": "रिपोर्ट समय",
        "reportIp": "रिपोर्ट IP",
        "logInfo": "लॉग जानकारी",
        "details": "विवरण",
        "confirmDeletion": "क्या आप हटाना चाहते हैं？",
        "logDetails": "लॉग विवरण",
        "download": "डाउनलोड करें",
        "deptOrg": "विभाग संगठन",
        "query": "क्वेरी",
        "queryByTerminalId": "टर्मिनल आईडी के अनुसार क्वेरी",
        "batchDeleteLogs": "बैच लॉग हटाएं",
        "customTimeDeleteLogs": "अनुकूलित समय लॉग हटाएं",
        "selectTimeRangeFirst": "कृपया पहले समय सीमा चुनें",
        "deleteAllDeviceLogsIfEmpty": "यदि डिवाइस आईडी नहीं भरा है, तो डिफ़ॉल्ट रूप से सभी डिवाइस के लॉग हटा दिए जाएंगे",
        "enterDeviceIdToDeleteLogs": "कृपया लॉग हटाने के लिए डिवाइस आईडी दर्ज करें",
        "confirmDeleteAction": "हटाने की पुष्टि करें",
        "selectDeleteRangeFirst": "कृपया पहले हटाने की सीमा चुनें",
        "networkConnectionFailed": "नेटवर्क कनेक्शन विफल",
        "playLog": "प्ले लॉग",
        "publishLog": "प्रकाशन लॉग",
        "errorLog": "त्रुटि लॉग",
        "operationLog": "संचालन लॉग",
        "fileLog": "फ़ाइल लॉग",
        "userOperateLog": "लॉगिन लॉग"
    },
    "userManual": {
        "userManual": "उपयोगकर्ता मैनुअल",
        "noData": "कोई डेटा नहीं"
    },
    "systemNotice": {
        "systemNotice": "सिस्टम सूचना",
        "noData": "कोई डेटा नहीं",
        "total": "कुल",
        "totalNum": "पंक्तियां",
        "markAllRead": "सभी को पढ़ा हुआ के रूप में चिह्नित करें",
        "deleteAll": "सभी को हटाएं",
        "all": "सभी",
        "unread": "अपठित",
        "read": "पढ़ा हुआ",
        "type": "प्रकार",
        "content": "सामग्री",
        "date": "तारीख",
        "status": "स्थिति",
        "confirmDelete": "क्या आप हटाने की पुष्टि करते हैं？",
        "confirm": "निश्चित करें",
        "cancel": "रद्द करें",
        "delete": "हटाएं"
    }
};